import {FACTS} from './facts';

export const getRandomFact = () => {
  const index = Math.floor(Math.random() * FACTS.length);

  return FACTS[index] ?? FACTS[0];
};
